

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  createMedia,
  createMultiImage,
  deleteMedia,
} from "../../features/admin/MediaSlice";
import ApiCustom from "../../utils/ApiCustom";
const mediaSchema = Yup.object().shape({
  image: Yup.mixed().required("Vui lòng chọn ảnh"),
});

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const userId = localStorage.getItem("userId");
const hasPermission = (requiredPermission) => {
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const MediaModal = ({
  media,
  onClose,
  multiImage = false,
  avatarType = false,
  onSaveMedia = null,
  imageableId = null,
  imageableType = null,
  imageType = null,
}) => {
  const [image, setImage] = useState(null);
  const [images, setImages] = useState(null);
  const [preview, setPreview] = useState(media ? media.url : "");
  const [previewMultiImage, setPreviewMultiImage] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const dispatch = useDispatch();
  const { error: apiError } = useSelector((state) => state.medias);

  useEffect(() => {
    console.log(previewMultiImage);
  }, [previewMultiImage]);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      setError("Chỉ chấp nhận file ảnh (JPEG, PNG, GIF, JPG)");
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      setError("Kích thước file không được vượt quá 2MB");
      return;
    }

    setImage(file);
    setError(null);

    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleMultiChange = (e) => {
    setPreviewMultiImage([]);
    const files = Array.from(e.target.files);
    if (!files) return;

    if (files.length > 50) {
      setError("Tối đa 50 ảnh");
      return;
    }

    const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/jpg"];
    for (let file of files) {
      if (!allowedTypes.includes(file.type)) {
        setError("Chỉ chấp nhận file ảnh (JPEG, PNG, GIF, JPG)");
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        setError("Kích thước file không được vượt quá 2MB");
        return;
      }
    }

    setImages(files);
    setImage(files[0]);

    setError(null);

    for (let file of files) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setPreviewMultiImage((prev) => [...prev, reader.result]);
      };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await mediaSchema.validate({ image });

      const formData = new FormData();

      if (!multiImage) {
        formData.append("files", image);
      } else {
        images.forEach((file) => {
          formData.append("files[]", file);
        });
      }

      setIsLoading(true);

      let res;
      if (imageableType && imageType) {
        if (imageableId) {
          formData.append("imageableId", imageableId);
        }
        formData.append("imageableType", imageableType);
        formData.append("imageType", imageType);
      }
      if (multiImage) {
        res = await dispatch(createMultiImage(formData));
      } else {
        // if (imageableType && imageType) {
        //   formData.append("imageableId", imageableId ?? null);
        //   formData.append("imageableType", imageableType);
        //   formData.append("imageType", imageType);
        //
        res = await dispatch(createMedia(formData));
      }

      if (res.meta.requestStatus === "fulfilled") {
        if (onSaveMedia) {
          await onSaveMedia(res?.payload?.data);
        }
        toast.success("Thêm hình ảnh thành công!");
        onClose();
      }
    } catch (validationError) {
      setError(validationError.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!media) return;
    setIsLoading(true);
    const res = await dispatch(deleteMedia(media.id));
    if (res.meta.requestStatus === "fulfilled") {
      toast.success("Xóa hình ảnh thành công!");
      onClose();
    } else {
      toast.error("Xóa không thành công!");
    }

    setIsLoading(false);
  };

  const selectBanner = async (media) => {
    ApiCustom.put("/change-banner/" + media?.id, { isBanner: true })
      .then((res) => {
        toast.success("thay đổi banner thành công");
        onClose();
      })
      .catch((err) => console.log(err));
  };

  const unSelectBanner = async (media) => {
    ApiCustom.put("/change-banner/" + media?.id, { isBanner: false })
      .then((res) => {
        toast.success("thay đổi banner thành công");
        onClose();
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center max-lg:px-6 z-[9999]">
      <div
        className={`bg-base-100 rounded-lg ${
          avatarType
            ? "w-1/2"
            : !media
            ? "xl:w-5/6 lg:w-11/12 md:w-full sm:w-full"
            : "w-96"
        } max-h-[90vh] overflow-y-auto shadow-lg`}
      >
        <div className="flex justify-between sticky top-0 bg-base-100 z-10 max-h-16">
          <div className="p-6 pb-0">
            <h2 className="text-xl font-semibold mb-4">
              {media ? "Chi tiết hình ảnh" : "Thêm hình ảnh"}
            </h2>
          </div>

          {media && (
            <div className="pt-6 pr-6">
              <button
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(media.url);
                  toast.success("Đã sao chép URL hình ảnh");
                }}
                className="px-4 py-2 btn btn-outline btn-info btn-sm rounded ml-4"
              >
                Sao chép URL
              </button>
            </div>
          )}
        </div>
        <form>
          <div className="mb-4">
            <div className="px-6 pb-2 sticky top-16 bg-base-100 z-10">
              <label htmlFor="image" className="block text-sm font-medium mb-1">
                {media ? "Hình ảnh hiện tại" : "Chọn hình ảnh"}
                <i className="text-red-600"> *</i>
              </label>
              {!media && (
                <input
                  type="file"
                  multiple={multiImage}
                  name="image"
                  accept="image/jpeg,image/png,image/gif"
                  onChange={multiImage ? handleMultiChange : handleChange}
                  className="file-input file-input-bordered w-full"
                  disabled={isLoading}
                />
              )}
            </div>

            {preview && (
              <div className="mt-2 flex justify-center">
                <img
                  src={preview}
                  alt="Preview"
                  className="h-40 w-40 object-contain rounded-lg shadow-md"
                />
              </div>
            )}

            {multiImage && previewMultiImage?.length > 0 && (
              <div className="px-6">
                <div className="grid lg:grid-cols-6 md:grid-cols-4 max-lg:grid-cols-3 sm:gap-4 max-lg:gap-2">
                  {previewMultiImage.map((image) => (
                    <div className="mt-2 w-full flex justify-center round-lg">
                      <img
                        src={image}
                        alt="Preview"
                        className="h-32 lg:h-38 xl:h-48 w-full rounded-lg shadow-md object-contain"
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
          </div>
          {media && hasPermission("MEDIA_UPDATE") && (
            <div className="flex items-center justify-between px-6">
              {media?.isBanner
                ? "Hình ảnh là banner"
                : "Hình ảnh chưa là banner"}
              {media?.isBanner ? (
                <button
                  type="button"
                  onClick={() => unSelectBanner(media)}
                  className="px-4 py-2 btn btn-outline btn-error btn-sm rounded"
                  disabled={isLoading}
                >
                  {isLoading ? "Đang lưu..." : "Huỷ banner"}
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() => selectBanner(media)}
                  className="px-4 py-2 btn btn-outline btn-success btn-sm rounded"
                  disabled={isLoading}
                >
                  {isLoading ? "Đang Xử lý..." : "Chọn làm banner"}
                </button>
              )}
            </div>
          )}
          <div className="flex justify-between p-6 pt-4 sticky bottom-0 bg-base-100 z-10">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded btn btn-sm"
              disabled={isLoading}
            >
              Đóng
            </button>
            {media ? (
              <div>
                {hasPermission("MEDIA_DELETE") && (
                  <button
                    type="button"
                    onClick={handleDelete}
                    className="px-4 py-2 btn btn-error rounded btn-sm"
                    disabled={isLoading}
                  >
                    {isLoading ? "Đang xóa..." : "Xóa"}
                  </button>
                )}
              </div>
            ) : (
              <button
                type="submit"
                className="px-4 py-2 btn btn-primary btn-sm rounded"
                disabled={isLoading}
                onClick={!isLoading ? handleSubmit : null}
              >
                {isLoading ? "Đang lưu..." : "Lưu"}
              </button>
            )}
          </div>
          {apiError && (
            <p className="text-red-500 text-sm mt-2">
              Đã xảy ra lỗi: {apiError.message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default MediaModal;
